import Cookies from "js-cookie";

// _cioid is a customer.io cookie that needs to be removed upon user logout.
const removableInspireCookies = ["_cioid"];

/**
 * Remove Inspire Cookies upon user logout.
 */
export const removeInspireCookies = () => {
  return removableInspireCookies.forEach((removeableCookie) => {
    Cookies.remove(removeableCookie);
  });
};
